"use client";
import Modal from "@/components/Modal";
import Image from "next/image";
import { useEffect, useState } from "react";
import Power from "@/components/icons/power";
import Button from "@/components/form/button";

const WebsitePopupModal = ({ message }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [countdown, setCountdown] = useState(5);

  const { headings, contentFields, note } = message;

  useEffect(() => {
    if (!isOpen) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          setIsOpen(false);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="relative w-full text-sm max-h-[80vh] mt-2 overflow-y-auto max-w-[90vw] md:max-w-[600px] lg:max-w-[700px] mx-auto bg-gradient-to-b from-[#D9DFFE] to-[#EDF0FF] rounded-xl border border-gray-200 overflow-hidden my-3">
        {isOpen && countdown > 0 && (
          <div className="absolute top-2 right-4 text-xs text-gray-800 font-semibold z-10">
            <span className="font-bold text-xl text-green-2">
              {" "}
              {countdown}{" "}
            </span>
            's
          </div>
        )}

        <div className="flex flex-col lg:flex-row md:justify-between items-start lg:items-center gap-3 md:gap-0 p-2 bg-white">
          <div className="flex items-center gap-2">
            <Image
              src="/assets/images/new_design/website.webp"
              alt="kuppam-logo"
              className="w-14 h-14 md:w-16 md:h-16"
              width={180}
              height={180}
              sizes="(max-width: 640px) 60px, (max-width: 768px) 70px, (max-width: 1280px) 80px, 90px"
              loading="eager"
            />
            <div>
              <p className="text-[#002C69] text-sm md:text-base xl:text-base font-bold xl:font-extrabold leading-tight">
                కుప్పం గ్రామీణ విద్యుత్ సహకార సంస్థ లిమిటెడ్
              </p>
              <p className="text-red-600 text-xs font-semibold md:ml-3">
                KUPPAM RURAL ELECTRIC CO-OPERATIVE SOCIETY LIMITED
              </p>
            </div>
          </div>

          <div className="text-sm text-[#001436] font-medium md:mt-2 lg:mt-0">
            Toll-Free{" "}
            <span className="text-red-600 font-semibold">
              :: 1800 425 505 505
            </span>
          </div>
        </div>

        <div className="p-2 md:px-6 text-gray-800">
          <h2 className="text-[#011031] font-bold text-lg sm:text-xl mb-3 text-center leading-snug">
            {headings[0]} <br />
            {headings[1]}{" "}
            <span className="text-2xl sm:text-3xl text-green-2">
              {headings[2]}
            </span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-[15px] mt-4 text-left">
            <ul className="space-y-2 list-disc list-inside text-green-2">
              {contentFields.slice(0, 5).map((field, i) => (
                <li key={i} className="flex items-center gap-2">
                  <Power />
                  {field}
                </li>
              ))}
            </ul>
            <ul className="space-y-2 list-disc list-inside text-green-2">
              {contentFields.slice(5).map((field, i) => (
                <li key={i + 5} className="flex items-center gap-2">
                  <Power />
                  {field}
                </li>
              ))}
            </ul>
          </div>

          <p className="mt-5 text-[16px] text-gray-800 font-bold leading-relaxed border-t border-gray-300 pt-3">
            {note}
          </p>
        </div>

        <div className="flex justify-end px-4 sm:px-6 pb-4">
          <Button
            text="Close"
            className="bg-green-1 text-white hover:text-green-2 font-xl hover:bg-green-6 px-6 py-2 rounded font-bold"
            onClick={() => setIsOpen(false)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default WebsitePopupModal;
